import Component from "./PuppyPoolParty";
export default Component;
